import { EnvironmentProviders, Provider } from '@angular/core';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';

export interface ApiConfig {
  api: string;
}

export function validateEnvironment(env: Environment): void {
  const apiConfigs: [string, ApiConfig][] = [
    ['appmanagement', env.appmanagement],
    ['locations', env.locations],
    ['groups', env.groups],
    ['settings', env.settings],
    ['mdm', env.mdm],
    ['dep', env.dep],
    ['inroom', env.inroom],
    ['gateway', env.gateway],
    ['osupdates', env.osupdates],
    ['devicetaskmanagement', env.devicetaskmanagement],
    ['apple-sync', env.applesync],
    ['ireckonintegration', env.ireckonintegration],
  ];

  for (const [name, config] of apiConfigs) {
    if (!config.api) {
      throw new Error(`Environment misconfiguration: missing API string for "${name}"`);
    }
  }
}

export interface LocationsApiConfig extends ApiConfig {
  enroll: string;
  qrForeground: string;
  pairUrl: string;
}

export interface MdmApiConfig extends ApiConfig {
  frontend: string;
  deviceUrl: string;
  enrollUrl: string;
}

export interface OidcConfig extends OpenIdConfiguration {
  domain_hint?: string | null;
}

export interface AppInsightsConfig {
  instrumentationKey: string;
}

export interface SentryConfig {
  enabled: boolean;
  dsn: string;
  environment: string;
  release: string;
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
  captureLogs: boolean;
}

export interface Environment {
  production: boolean;
  local: boolean;
  appInsights: AppInsightsConfig;
  sentry: SentryConfig;
  appmanagement: ApiConfig;
  locations: LocationsApiConfig;
  groups: ApiConfig;
  settings: ApiConfig;
  mdm: MdmApiConfig;
  dep: ApiConfig;
  inroom: ApiConfig;
  gateway: ApiConfig;
  osupdates: ApiConfig;
  devicetaskmanagement: ApiConfig;
  applesync: ApiConfig;
  ireckonintegration: ApiConfig;
  oidc: OidcConfig[];
  maximumSyncLoad: number;
  features: EnvironmentFeatures;
  extModules?: (Provider | EnvironmentProviders)[];
}
